"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitData = exports.sort = exports.initState = void 0;
var react_1 = require("react");
exports.initState = {
    items: [],
    selectedItems: [],
    sessionItems: [],
    search: '',
    isLoading: '',
    open: false
};
var getValidValue = function (value) {
    if (!value && typeof value === 'object')
        return '';
    switch (typeof value) {
        case 'object':
        case 'boolean':
        case 'function':
            return value.toString().toLowerCase();
        case 'undefined':
            return '';
        default:
            return value;
    }
};
var sort = function (items, param) {
    if (items === void 0) { items = []; }
    return items.sort(function (a, b) { return (getValidValue(a[param])
        > getValidValue(b[param]) ? 1 : -1); });
};
exports.sort = sort;
function reducer(state, _a) {
    var type = _a.type, value = _a.value;
    switch (type) {
        case 'SET_ITEMS':
            return __assign(__assign({}, state), { items: value });
        case 'SET_SELECTED_ITEMS':
            return __assign(__assign({}, state), { selectedItems: value });
        case 'SET_SEARCH':
            return __assign(__assign({}, state), { search: value });
        case 'SET_SESSION_ITEMS':
            return __assign(__assign({}, state), { sessionItems: value });
        case 'SET_STATUS':
            return __assign(__assign({}, state), { isLoading: value });
        case 'SET_OPEN':
            return __assign(__assign({}, state), { open: value });
        case 'LOAD_SEARCH':
            return __assign(__assign({}, state), { isLoading: value.isLoading });
        case 'ERROR_LOAD_SEARCH':
            return __assign(__assign({}, state), { isLoading: 'error', items: value.items, search: value.search });
        case 'SUCCESS_LOAD_SEARCH':
            return __assign(__assign({}, state), { isLoading: 'loaded', items: value.items, search: value.search });
        default:
            return state;
    }
}
var useInitData = function (_a) {
    var defaultValue = _a.defaultValue;
    var _b = (0, react_1.useReducer)(reducer, defaultValue ? __assign(__assign({}, exports.initState), { selectedItems: defaultValue }) : exports.initState), state = _b[0], dispatch = _b[1];
    var selectedItems = state.selectedItems, items = state.items, sessionItems = state.sessionItems;
    var selectedItemsMap = (0, react_1.useMemo)(function () { return state.selectedItems.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item.key] = item, _a)));
    }, {}); }, [state.selectedItems]);
    var listItems = (0, react_1.useMemo)(function () {
        if (state.search.trim().length) {
            return __spreadArray([], (0, exports.sort)(items, 'value'), true);
        }
        return __spreadArray(__spreadArray([], selectedItems, true), (0, exports.sort)(items, 'value').filter(function (item) { return !selectedItemsMap[item.key]; }), true);
    }, [selectedItemsMap, selectedItems, items, state.search]);
    var amountItems = (0, react_1.useMemo)(function () { return listItems.length; }, [listItems]);
    var allSelectedItemsMap = (0, react_1.useMemo)(function () {
        var newSelectedItemsMap = __assign({}, selectedItemsMap);
        sessionItems.forEach(function (_a) {
            var key = _a.key, value = _a.value, isChecked = _a.isChecked, anyProps = __rest(_a, ["key", "value", "isChecked"]);
            if (isChecked) {
                newSelectedItemsMap[key] = __assign(__assign({}, anyProps), { key: key, value: value });
            }
            if (!isChecked && newSelectedItemsMap[key]) {
                delete newSelectedItemsMap[key];
            }
        });
        return __assign({}, newSelectedItemsMap);
    }, [selectedItemsMap, sessionItems]);
    var allSelectedItems = (0, react_1.useMemo)(function () { return Object.keys(allSelectedItemsMap)
        .map(function (key) { return allSelectedItemsMap[key]; }); }, [allSelectedItemsMap]);
    return __assign(__assign({}, state), { selectedItemsMap: selectedItemsMap, dispatch: dispatch, amountItems: amountItems, listItems: listItems, allSelectedItemsMap: allSelectedItemsMap, allSelectedItems: allSelectedItems });
};
exports.useInitData = useInitData;
